import React from "react";
import Table from "./Table"; // new

function TableData() {
 
  const data = [
    {
      product_id: "JHBN52",
        date: "13-03-2022",
        status: "Faulty",
    },
    {
      product_id: "JHBN52",
        date: "13-03-2022",
        status: "Damaged",
    },
    {
      product_id: "JHBN52",
        date: "13-03-2022",
        status: "Faulty",
    },
    {
        product_id: "JHBN52",
        date: "13-03-2022",
        status: "Damaged",
    },
  ]

  const columns = React.useMemo(
    () => [
      {
        Header: "Rejected tems",
        accessor: "product_id",
      },
      {
        Header: "Reported On",
        accessor: "date",
      },
      {
        Header: "Reason",
        accessor: "status",
      },
      
    ],
    []
  );

  return (
    <div className="mb-4">
      <main className="max-w-full px-4 sm:px-6 lg:px-8 pt-4">
        <div className="mt-4">
          <Table
            columns={columns}
            data={data == undefined ? [] : data}
            text="Undefined"
          />
        </div>
      </main>
    </div>
  );
}

export default TableData;
